import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["left", "right"];

  connect() {
    for (const option of this.rightTarget.options) {
      option.selected = false;
    }
  }

  moveRight() {
    this.move(this.leftTarget, this.rightTarget);
  }

  moveLeft() {
    this.move(this.rightTarget, this.leftTarget);
  }

  moveAllRight() {
    this.move(this.leftTarget, this.rightTarget, true);
  }

  moveAllLeft() {
    this.move(this.rightTarget, this.leftTarget, true);
  }

  move(from, to, all = false) {
    let options = [];

    for (const option of from.options) {
      if ((all || option.selected) && !option.hidden) {
        options.push(option);
      }
    }

    for (const option of options) {
      to.appendChild(option);
      option.selected = false;
    }

    this.sort(from);
    this.sort(to);
  }

  // I stole this from https://stackoverflow.com/a/50127768/1343921
  sort(select) {
    [...select.children]
      .sort((a, b) => (a.text > b.text ? 1 : -1))
      .forEach((option) => select.appendChild(option));
    this.fireEvent(select);
  }

  selectAllRight() {
    for (const option of this.rightTarget.options) {
      option.selected = true;
    }
  }

  fireEvent(target) {
    const event = new CustomEvent("listupdate");
    target.dispatchEvent(event);
  }
}
